import type { DeviceDto } from "@ied/shared-types";
import {
	createColumnHelper,
	getCoreRowModel,
	type TableOptions,
} from "@tanstack/react-table";
import { useGetDevices } from "@/hooks/queries/use-get-devices";
import { Button } from "../ui/button";
import { TanstackTable } from "../ui/table";

export function DevicesTable() {
	const { data } = useGetDevices();

	if (!data) {
		return <p>No devices</p>;
	}
	const cHelper = createColumnHelper<DeviceDto>();
	const columns = [
		cHelper.accessor("id", {
			header: () => "Id",
		}),
		cHelper.accessor("token", {
			header: () => "Token",
			cell: (props) => {
				const token = props.getValue();
				return `${token.substring(0, 20)}...`;
			},
		}),
		cHelper.accessor("enabled", {
			header: () => "Status",
			cell: (props) => {
				return props.getValue() === 1 ? "Enabled" : "Disabled";
			},
		}),
		cHelper.accessor("is_tester", {
			header: () => "Test Device",
			cell: (props) => {
				return props.getValue() ? "Yes" : "No";
			},
		}),
		cHelper.accessor("type", {
			header: () => "Device Type",
		}),
		cHelper.accessor("created", {
			header: () => "Created",
			cell: (row) => (
				<div>
					<p>{new Date(row.getValue()).toLocaleDateString()}</p>
					<p>{new Date(row.getValue()).toLocaleTimeString()}</p>
				</div>
			),
		}),
		cHelper.accessor("updated", {
			header: () => "Updated",
			cell: (row) => (
				<div>
					<p>{new Date(row.getValue()).toLocaleDateString()}</p>
					<p>{new Date(row.getValue()).toLocaleTimeString()}</p>
				</div>
			),
		}),
	];
	const tableOptions: TableOptions<DeviceDto> = {
		columns,
		data,
		getCoreRowModel: getCoreRowModel(),
	};
	return (
		<>
			<TanstackTable options={tableOptions} />
		</>
	);
}
